import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=d4b1e164&scoped=true"
import script from "./editor.vue?vue&type=script&setup=true&lang=js"
export * from "./editor.vue?vue&type=script&setup=true&lang=js"
import style0 from "./editor.vue?vue&type=style&index=0&id=d4b1e164&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b1e164",
  null
  
)

export default component.exports